<template>
  <NTimeline class="c-timeline">
    <NTimelineItem
      v-for="(item, index) of data"
      :key="item.time"
      class="c-timeline__item cursor-pointer"
      :class="{
        'c-timeline__item--active': item.active,
      }"
      v-bind="item"
      :style="getStyle(item, index)"
      @click="selectItem(item)"
    >
      <template v-if="item.icon" #icon>
        <CIcon :icon="item.icon" size="14" />
      </template>
    </NTimelineItem>
  </NTimeline>
</template>

<script lang="ts" setup>
import { NTimeline, NTimelineItem, type TimelineItemProps } from 'naive-ui'

import useThemeVars from '@lib/composables/useThemeVars'
import CIcon from '@lib/components/CIcon/CIcon.vue'

export interface ExtendedTimelineItemProps extends TimelineItemProps {
  active?: boolean
  icon?: string
  id: string
}

const props = defineProps<{
  data: ExtendedTimelineItemProps[]
}>()

const emit = defineEmits<{ 'item-activated': [i: ExtendedTimelineItemProps] }>()

const themeVars = useThemeVars()

const selectItem = (item: ExtendedTimelineItemProps) => {
  emit('item-activated', item)
}

const getStyle = (item: ExtendedTimelineItemProps, index: number) => {
  const activeItemIndex = props.data.findIndex((i) => i.active)

  const styles: any = {
    '--n-line-color': 'rgba(0,0,0,0.12)',
  }

  if (index < activeItemIndex) {
    styles['--n-title-text-color'] = themeVars.value.primary4
    styles['--n-meta-text-color'] = themeVars.value.primary4
  }

  return styles
}
</script>
<style scoped>
.c-timeline :deep(.c-timeline__item--active .n-timeline-item-content__title:before) {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  border-radius: 50%;
  background: var(--p-success);
}
</style>
